import React from 'react';

const Logo = ({ className = "", variant = "auto" }) => {
  // variant can be: "light" (white logo), "dark" (dark logo), "auto" (based on theme)
  const fill = variant === "light" ? "#eeeded" : variant === "dark" ? "#1a1a1a" : "currentColor";
  
  return (
    <svg 
      viewBox="0 0 298.82 214.08" 
      className={className}
      fill={fill}
    >
      <path d="M24.7,119.71v15c13.18,0,23.02,6.51,23.02,12.34s-9.85,12.33-23.02,12.33v15c21.32,0,38.02-12.01,38.02-27.33s-16.7-27.34-38.02-27.34Z"/>
      <path d="M110.06,118.38c-17.29,0-31.36,17.06-31.36,38.02v57.67h15v-57.67c0-12.48,7.49-23.02,16.36-23.02s16.36,10.54,16.36,23.02v57.67h15v-57.67c0-20.96-14.07-38.02-31.36-38.02Z"/>
      <rect x="101.66" y="159.38" width="16.8" height="15"/>
      <path d="M220.11,147.04c0-15.33-16.7-27.34-38.02-27.34v15c13.18,0,23.02,6.51,23.02,12.34s-9.84,12.33-23,12.34h-.02v15h.02c12.47.02,23.01,18.19,23.01,39.7h15c0-18.67-6.2-34.87-15.85-44.7,9.65-4.91,15.84-13.01,15.84-22.34Z"/>
      <rect x="236.1" y="119.68" width="15" height="94.39"/>
      <path d="M279.81,167.26c11.44-9.33,19.01-26.94,19.01-47.58h-15c0,21.52-10.54,39.7-23.02,39.7v.03c-.31,0-.61-.03-.92-.03v15c12.48,0,23.02,18.18,23.02,39.7h15c0-20.09-7.17-37.32-18.09-46.82Z"/>
      <path d="M120.34,62.17c-4.12,16.34-8.73,21.63-10.28,22.4-1.55-.77-6.16-6.06-10.28-22.4-3.92-15.56-6.08-35.91-6.08-57.31h-15c0,35.2,6.6,94.76,31.36,94.76s31.36-59.56,31.36-94.76h-15c0,21.4-2.16,41.75-6.08,57.31Z"/>
      <path d="M31.36,0C14.07,0,0,17.06,0,38.02v176.05h15V38.02c0-12.48,7.49-23.02,16.36-23.02s16.36,10.54,16.36,23.02v57.67h15v-57.67C62.72,17.06,48.65,0,31.36,0Z"/>
      <rect x="22.96" y="40.99" width="16.8" height="15"/>
      <path d="M182.09,4.89v15c13.18,0,23.02,6.51,23.02,12.34h15c0-15.33-16.7-27.34-38.02-27.34Z"/>
      <polygon points="157.4 99.26 157.4 214.07 172.4 214.07 172.4 99.26 172.4 4.86 157.4 4.86 157.4 99.26"/>
      <path d="M182.09,84.62v15c21.32,0,38.02-12.01,38.02-27.34h-15c0,5.83-9.84,12.34-23.02,12.34Z"/>
      <rect x="182.09" y="44.56" width="16.8" height="15"/>
    </svg>
  );
};

export default Logo;
